import React from 'react';

import { Button } from '../../../../../components/ui/buttons/Button';

const StepButtonLink = ({
  color,
  onClick,
  children,
}: {
  color: string;
  onClick?: () => void;
  children: React.ReactNode;
}) => (
  <Button
    variant="link"
    fontSize={{ base: 'md', md: 'lg' }}
    color={color}
    mt={1}
    onClick={onClick}
    fontWeight="bold"
    textAlign="left"
  >
    {children}
  </Button>
);

export default StepButtonLink;
